<script>
    import blockUI from './BlockUIService.js';
    import moment from 'moment';
    import DataService from './DataService.js';
    import CryptoJS from 'crypto-js';
    export default {
        data() {
            return {
                loginDetails: '',

                


                Categories: [],
                Branches: [],
                Customers: [],
                Suppliers: [],
                PaymentsMethods: [],
                Stocking: [],

                Products: [],
                ProductsCounts: [],
                Users: [],

                
                
                

                
               


                //Cities: [],
                //Municipalities: [],
                //Locations: [],
                
                //PaymentsMethods: [],
                //Customers: [],
                //FromCustomers: [],
                //ToCustomers: [],


                //Distributors: [],

                /*Publeish*/
                //ServerUrl: 'https://dashboard.platform.traneem.ly',

                /*Local*/
                ServerUrl: 'http://localhost:5000',
                Facebock: 'https://www.facebook.com/p/Traneem-100064940462078/?locale=ar_AR',
                Instagram: 'https://www.instagram.com/traneem5__/',
                TraneemPhone: '+218 94 457 81 48',
                TraneemEmail: 'info@traneem.ly',
                PlatFormPass: 'Traneem!@Platformv1',


                WebSiteName: ' الحلول الطبية ',
                BuildFor: 'شركة الحلول الطبية ',
                logoPath: '/assets/img/1/logo1.jpg',
                CoverPath: '/assets/img/illustrations/auth-register-illustration-dark.png',
                PdfPath: '/assets/img/icons/misc/pdf1.png',

            }
        },
        methods: {

            encrypt: function encrypt(data, SECRET_KEY) {
                var dataSet = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY);
                dataSet = dataSet.toString();
                return dataSet;
            },
            decrypt: function decrypt(data, SECRET_KEY) {
                data = CryptoJS.AES.decrypt(data, SECRET_KEY);
                data = JSON.parse(data.toString(CryptoJS.enc.Utf8));
                return data;
            },

            ClearForm(ruleForm) {
                for (const key in ruleForm) {
                    if (Array.isArray(ruleForm[key])) {
                        ruleForm[key] = []; // Reset to an empty array if it's an array
                    } else {
                        ruleForm[key] = ''; // Reset to an empty string for other types
                    }
                }
            },

            async CheckLoginStatus() {
                try {
                    this.loginDetails = JSON.parse(this.decrypt(localStorage.getItem('currentUser-client'), this.PlatFormPass));
                    const res = await DataService.IsLoggedin();
                    if (!res.data)
                        this.logout();
                } catch (error) {
                    this.logout();
                }
            },

            async logout() {
                localStorage.removeItem('currentUser-client');
                localStorage.clear();
                document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
                
                this.$http.Logout()
                    .then(() => {
                        window.location.href = "/";
                    })

                window.location.href = "/";
            },


            formatNumber(num) {
                if (num) {
                    if (num <= 0) {
                        return 0;
                    } else {
                        return new Intl.NumberFormat('en-US').format(num); // Format the number
                    }
                } else {
                    return 0;
                }
            },

            moment(date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('DD/MM/YYYY');
            },

            momentTime (date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('DD/MM/YYYY ||  h:mm a');
            },

            momentYear(date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('YYYY-MM');
            },

            ChangeDate(date) {
                    if (date === null) {
                        return "فارغ";
                    }
                    return moment(date).format("YYYY-MM-DD");
            },

            GetTodayDate() {
                const today = new Date();
                // Format date as YYYY-MM-DD
                const year = today.getFullYear();
                const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
                const day = today.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            },



            async GetAllStocking() {
                this.Stocking = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllStocking();
                    this.Stocking = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllCategories() {
                this.Categories = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllCategories();
                    this.Categories = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllBranches() {
                this.Branches = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllBranches();
                    this.Branches = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllCustomers() {
                this.Customers = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllCustomers();
                    this.Customers = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllSuppliers() {
                this.Suppliers = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllSuppliers();
                    this.Suppliers = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllProducts() {
                this.Products = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllProducts();
                    this.Products = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllProductsCounts() {
                this.ProductsCounts = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllProductsCounts();
                    this.ProductsCounts = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllPaymentsMethods() {
                this.PaymentsMethods = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllPaymentsMethods();
                    this.PaymentsMethods = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllUsers() {
                this.Users = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllUsers();
                    this.Users = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },




           
        }
    }
</script>
